import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { StorageService } from './common/services/storage.service';
import { AuthService } from './common/services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { KeycloakEventType, KeycloakService } from 'keycloak-angular';
import { ResizeWindowService } from './common/services/resize-window.service';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { ApplicationsSearchObservableService } from './common/services/applications-search-observable.service';
import { LayoutModule } from './layout/layout.module';
import { UtilsService } from './common/services/utils.service';
import { MatDialog } from '@angular/material/dialog';
import jwtDecode from 'jwt-decode';

@AutoUnsubscribe()
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [LayoutModule],
  standalone: true
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'market-place';
  width: number = window.innerWidth;
  height: number = window.innerHeight;
  isDesktop = false;
  theme = 'marketplace-default';
  isLoading = true;
  userLogIn = true;
  isAdmin = false;
  isCompanyAdmin = false;
  userMainRole: string;
  userName = '';
  userAvatar = '';
  userProfile;
  utilsService = inject(UtilsService);

  constructor(
    private readonly resizeWindowService: ResizeWindowService,
    private storageService: StorageService,
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    public matDialog: MatDialog,
    private applicationsSearchObservableService: ApplicationsSearchObservableService,
    private readonly keycloak: KeycloakService
  ) {
    {
      keycloak.keycloakEvents$.subscribe({
        next(event) {
          if (event.type == KeycloakEventType.OnTokenExpired) {
            keycloak.updateToken(5);
          }
        }
      });
    }
  }

  async ngOnInit() {
    this.isLoading = true;
    this.userLogIn = await this.keycloak.isLoggedIn();
    if (window.location.pathname.includes('results')) {
      this.prepareSearch();
      this.storageService.setUrlReload(window.location.pathname);
    }

    this.initSubscriptions();
    if (this.userLogIn) {
      this.authService.setUserLoggedIn(true);
      this.isCompanyAdmin = this.keycloak.isUserInRole('role_marketplace_company_admin');
      this.isAdmin = this.keycloak.isUserInRole('role_marketplace_superadmin');
      localStorage.setItem('isAdmin', this.isAdmin.toString());
      const token = await this.keycloak.getToken();
      this.userProfile = await this.keycloak.loadUserProfile();
      this.userName = this.userProfile.firstName + ' ' + this.userProfile.lastName;
      let avatarFromJwt = '';
      try {
        const decoded: any = jwtDecode(token);
        if (typeof decoded?.avatar === 'string') avatarFromJwt = decoded.avatar;
      } catch {}
      this.userAvatar = avatarFromJwt;
      if (this.isAdmin) {
        this.authService.setIsAdmin(true);
        if (window.location.pathname.startsWith('/admin')) {
          this.router.navigate([window.location.pathname]);
        } else {
          this.router.navigate(['/admin/applications-list']);
        }
      } else {
        this.authService.setIsAdmin(false);
        if (window.location.pathname.startsWith('/public')) {
          this.router.navigate(['multicompany']);
        } else {
          if (window.location.pathname.includes('results')) {
            this.prepareSearch();
            this.storageService.setUrlReload(window.location.pathname);
          }
          /*       this.router.navigate([window.location.pathname]);*/
        }
      }
      this.isLoading = false;
    } else {
      this.authService.setUserLoggedIn(false);
      if (!window.location.pathname.startsWith('/public')) {
        this.storageService.removeStoreSearch();
        this.router.navigate(['/public/_home']);
      } else {
        this.router.navigate([window.location.pathname]);
      }
      this.isLoading = false;
    }
  }

  prepareSearch() {
    //Ej--->https://ved.mfr.barbara.tech/results?search=mqtt%20broker
    const search = new URLSearchParams(window.location.search).get('search');
    if (search) {
      this.applicationsSearchObservableService.setSearchValue(search);
      this.storageService.setStoreSearch(search);
      this.router.navigate(['multicompany']);
    }
  }

  initSubscriptions(): void {
    this.resizeWindowService.isDesktop$.subscribe((value: boolean) => {
      this.isDesktop = value;
    });
    this.resizeWindowService.width$.subscribe((value: number) => {
      this.width = value;
    });
  }

  ngOnDestroy(): void {}
}
